import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import LayoutImages from "../components/image/LayoutImages"
import EditMenu from "../components/image/EditMenu"
import MenuSubdir from "../components/image/MenuSubdir"
import ColumnView from "../components/view/columnView"


const IndexPage = () => (
  <Layout className="has-text-dark" >
    <SEO title="Home" keywords={[`foto`, `Tangokompaniet`]} />
    <LayoutImages>
      <EditMenu />
      <MenuSubdir />
      <ColumnView />
    </LayoutImages>    
  </Layout>
)

export default IndexPage

